//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/building'
import TopFilter from './_top_filter'
import HouseItem from './_house_item'
import CommonSelect from '@/components/form/common_select'
import BottomTip from '@/components/views/bottom_tip'

import pagination from '@/common/mixins/pagination'

import { handleItem } from './utils'

const DEFAULT_OPTION = {
    text: '全部',
    value: ''
}

export default {
    mixins: [
        pagination
    ],
    data () {
        return {
            per: 25,
            order_type: '',
            block_no: '',
            decoration_type: '',
            decorate_price: 0,
            order: '',
            unit: '',
            block_nos: [],
            units: [],
            decoration_types: [],
            house_decorate_prices: [],
            downpayment_percentage: [],
            status_opts: [],
            status: '',
            type: '',
            show_item_decorate_select: false,
            selected_item_index: -1,
            building_image_id: '',
            layout_image: {}
        }
    },
    computed: {
        decoration_price_tmp_empty () {
            console.error('decoration_price_tmp_empty', this.decoration_types, this.house_decorate_prices)
            return Boolean(this.decoration_types && this.decoration_types.length && this.decoration_types[0].value === '精装' && !this.house_decorate_prices.length)
        },
        selected_item_decorate_price () {
            let rs = -1
            const index = this.selected_item_index
            if (index === -1) {
                return rs
            }
            const { decorate_price } = this.items[index] ? this.items[index] : {}
            this.house_decorate_prices.some(({ value }, i) => {
                if (value === decorate_price) {
                    rs = i
                    return true
                }
            })
            return rs
        }
    },
    mounted () {
        const { building_image_id } = this.$route.query
        this.building_image_id = building_image_id
        this.getData()
    },
    methods: {
        getData () {
            const { house_id, type } = this.$route.query
            const filter = {
                per: this.per,
                page: this.page,
                block: this.block_no,
                decoration_type: this.decoration_type,
                order: this.order,
                order_type: this.order_type,
                unit: this.unit,
                status: this.status,
                building_image_id: this.building_image_id
            }
            this.loading = true
            this.type = type

            const is_surplus = type && type === 'surplus_apartments'

            const getList = is_surplus ? Service.houseSurplusApartments : Service.housePrice
            if (is_surplus) {
                this.status_opts = [
                    DEFAULT_OPTION,
                    {
                        text: '仅显示可售',
                        value: '可售'
                    }
                ]
            }
            getList(house_id, filter).then((data) => {
                this.layout_image = data.layout_image || {}
                const house_decorate_prices = data.house_decorate_prices || []
                this.block_nos = data.blocks.map((value) => {
                    return {
                        text: value,
                        value
                    }
                })
                this.block_nos.unshift(DEFAULT_OPTION)
                if (data.units && data.units.length) {
                    this.units = data.units.map(value => {
                        return {
                            text: value,
                            value
                        }
                    })
                    this.units.unshift(DEFAULT_OPTION)
                }

                this.decoration_types = data.decoration_types.map((value) => {
                    return {
                        text: value,
                        value
                    }
                })
                if (data.decoration_types.length > 1) {
                    this.decoration_types.unshift(DEFAULT_OPTION)
                }
                this.house_decorate_prices = house_decorate_prices.map(({ decorate_price, decorate_type, layout_type }) => {
                    return {
                        value: decorate_price,
                        text: `${decorate_price}元/㎡（${decorate_type}，适用${layout_type}）`
                    }
                })
                this.decorate_price = this.house_decorate_prices.length ? this.house_decorate_prices[0].value : 0
                this.downpayment_percentage = data.downpayment_percentage
                const items = this.handleItems(data.items)
                this.handleData({
                    items
                })
            })
        },
        handleItems (items, decorate_price = '') {
            const opt = {
                downpayment_percentage: this.downpayment_percentage
            }
            return items.map((item) => {
                opt.decorate_price =  decorate_price || this.decorate_price
                return handleItem(item, opt)
            })
        },
        showItemDecorateSelect (i) {
            this.selected_item_index = i
            this.show_item_decorate_select = true
            this.showSelect(this.show_item_decorate_select)
        },
        hideItemDecorateSelect () {
            this.show_item_decorate_select = false
            this.showSelect(this.show_item_decorate_select)
        },
        changeFilter (filter) {
            this.page = 1
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            this.getData()
        },
        changeDecoratePrice (price) {
            this.decorate_price = price
            this.items = this.handleItems(this.items, this.decorate_price)
        },
        changeItemDecorate (selected_index) {
            const index = this.selected_item_index
            const item = handleItem(this.items[index], {
                decorate_price: this.house_decorate_prices[selected_index].value,
                downpayment_percentage: this.downpayment_percentage
            })
            this.$set(this.items, index, item)
            this.hideItemDecorateSelect()
        },
        changeOrder (order) {
            this.page = 1
            this.order = order.value
            this.order_type = order.type
            this.getData()
        },
        removeScreen() {
            this.building_image_id = ''
            this.layout_image = {
                area: '',
                layout_no: ''
            }
            this.page = 1
            this.getData()
        },
        showSelect (show) {
            this.$emit('showSelect', show)
        }
    },
    components: {
        TopFilter,
        HouseItem,
        CommonSelect,
        BottomTip
    }
}
